import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SelfieSelectDialogComponent } from '@features/beautybook/components/selfie-select-dialog/selfie-select-dialog.component';
import { SelfieUploadDialogComponent } from '@features/beautybook/components/selfie-upload-dialog/selfie-upload-dialog.component';
import { BeautybookService } from '@features/beautybook/services/beautybook.service';
import {
  faArrowLeft,
  faCartShopping,
  faCodeCompare,
  faFileArrowUp,
  faImagePortrait,
  faRefresh,
  faShare,
} from '@fortawesome/free-solid-svg-icons';
import { DialogService } from 'primeng/dynamicdialog';
import { isPlatformBrowser } from '@angular/common';
import { forkJoin, map, mergeMap, takeUntil } from 'rxjs';
import { DataListParameter } from '@shared/interfaces/data-list-parameter.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from '@features/cart/services/cart.service';
import { ProductDetailService } from '@features/product/services/product-detail.service';
import { MessageService } from 'primeng/api';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-beautybook-add',
  templateUrl: './beautybook-add.component.html',
  styleUrls: ['./beautybook-add.component.css'],
})
export class BeautybookAddComponent implements OnInit {
  faCartShopping = faCartShopping;
  faArrowLeft = faArrowLeft;
  faRefresh = faRefresh;
  faShare = faShare;
  faCodeCompare = faCodeCompare;
  faImagePortrait = faImagePortrait;
  faFileArrowUp = faFileArrowUp;

  // dummy data
  isSelfieUploaded: Boolean = false;

  beautybookProductId = String(this.route.snapshot.paramMap.get('id'));
  beautybookProduct: any;
  beautybooKProductVariants: any;
  otherBeautybookProducts: any;
  selectedBeautybookProductVariant: any;
  selectedSelfie: any;
  selfies: any;
  product: any;
  resultImage: any;
  isProcessingMakeup: boolean = false;

  isLoading: boolean = false;
  loading = true;
  isBrowser = isPlatformBrowser(this.platformId);
  beautybookPostFormData = new FormData();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private dialogService: DialogService,
    private layoutService: LayoutService,
    private router: Router,
    private route: ActivatedRoute,
    private cartService: CartService,
    private productDetailService: ProductDetailService,
    private beautybookService: BeautybookService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    const otherBeautybookProductParam: DataListParameter = {
      item_per_page: 3,
      current_page: 1,
    };
    const beautybookProductParam: DataListParameter = {
      item_per_page: 1,
      current_page: 1,
      filters: [
        {
          field: 'id',
          operator: '=',
          value: this.beautybookProductId,
        },
      ],
    };

    this.beautybookService
      .getBeautybookProducts(beautybookProductParam)
      .pipe(
        map((beautybookProduct: any) => {
          this.beautybookProduct = beautybookProduct[0];

          return beautybookProduct[0];
        }),
        mergeMap((beautybookProduct: any) => {
          return forkJoin([
            this.beautybookService.getSelfies(),
            this.beautybookService.getBeautybookProducts(
              otherBeautybookProductParam
            ),
            this.beautybookService.getBeautybookProductVariant(
              beautybookProduct.id
            ),
            this.productDetailService.getProductDetail(
              beautybookProduct.product.slug
            ),
          ]);
        })
      )
      .subscribe(([selfies, otherProducts, productVariants, product]) => {
        if (selfies) {
          this.selfies = selfies;
        }
        if (otherProducts) {
          this.otherBeautybookProducts = otherProducts;
        }
        if (productVariants) {
          this.beautybooKProductVariants = productVariants;
        }
        if (product) {
          this.product = product;
        }
        this.loading = false;
      });
  }

  openSelectSelfieModal() {
    const ref = this.dialogService.open(SelfieSelectDialogComponent, {
      dismissableMask: true,
      closable: true,
      data: {
        selfies: this.selfies,
        selectedSelfie: this.selectedSelfie,
      },
      showHeader: false,
      width: '500px',
      contentStyle: {
        padding: '0',
      },
      style: {
        'border-radius': '1rem',
        overflow: 'hidden',
      },
    });
    ref.onClose.subscribe((selfie: any) => {
      if (selfie) {
        this.changeSelfie(selfie);
      }
    });
  }

  openUploadSelfieModal() {
    let style = {};
    if (this.layoutService.isMobile$.value) {
      style = {
        'max-height': '100%',
        width: '100vh',
        height: '100vh',
        overflow: 'hidden',
      };
    } else {
      style = {
        width: '500px',
        height: '600px',
        'border-radius': '1rem',
        overflow: 'hidden',
      };
    }
    const ref = this.dialogService.open(SelfieUploadDialogComponent, {
      dismissableMask: true,
      closable: true,
      showHeader: false,
      contentStyle: {
        padding: '0',
      },
      style: style,
    });
    ref.onClose.subscribe((selfie: any)=>{
      if (selfie) {
        this.changeSelfie(selfie);
      }
    })
  }

  changeSelfie(selfie: any) {
    this.resultImage = null;
    this.selectedSelfie = selfie;
  }

  selectBeautybookProductVariant(variant: any) {
    this.selectedBeautybookProductVariant = variant;
    if (this.selectedSelfie && this.selectedBeautybookProductVariant) {
      this.applyLipstick(this.selectedBeautybookProductVariant);
    }
  }

  addToCart() {
    this.cartService
      .addCartItem(
        this.beautybookProduct.product.id,
        this.selectedBeautybookProductVariant.productable.id,
        1
      )
      .subscribe((cartItem: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Product added to cart',
        });
      });
  }
  navigateToBeautybookProduct(id: number) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/beautybook/add', id], {
        replaceUrl: true,
      })
    );
  }

  submit(caption: string) {
    // this.beautybookService.getBlob(this.resultImage).subscribe((blob: any) => {
    //   console.log(blob);
    // });
    this.isLoading = true;
    this.beautybookPostFormData.append('caption', caption);
    this.beautybookPostFormData.append('image', this.resultImage);
    this.beautybookPostFormData.append(
      'post_products[0][product_id]',
      this.beautybookProductId
    );
    this.beautybookPostFormData.append(
      'post_products[0][product_variant_id]',
      this.selectedBeautybookProductVariant.id
    );

    this.beautybookService
      .addBeautybookPost(this.beautybookPostFormData)
      .subscribe((res: any) => {
        this.isLoading = false;
        this.router.navigate(['/beautybook/detail', res['data']['id']]);
      });
  }

  applyLipstick(variant: any) {
    this.isProcessingMakeup = true;
    this.beautybookService
      .applyLipstick({
        selfie: this.selectedSelfie.path,
        code: variant.old_group_code,
      })
      .subscribe((res: any) => {
        this.isProcessingMakeup = false;
        this.resultImage = `https://happybeauty.co.id/tmp/${res}_output.jpg`;
      });
  }
}
